/**
 * Welches Gerät hat diesen Sprechtasten-Zug geschickt? (29.09.2026, Ticket 2796)
 *
 * Martin, 29.09. 07:31: *„Jetzt wo du eine Karte anlegst, dauert es ewig,
 * bis der Browser die Karte anzeigt. Das muss schneller gehen, und zwar in
 * Realtime."*
 *
 * ## Warum es dauerte
 *
 * Der Kanal war da: `/api/chat/stream` schickt jede gespeicherte Nachricht an
 * alle Geräte des Kontos (server/message-bus.ts). Aber jedes Gerät warf
 * Sprechtasten-Nachrichten weg (frontend/app.ts, seit pre.148:
 * `if (m.source === "ptt") return;`) — gegen das Doppel auf dem Telefon, das
 * die Antwort schon selbst zeichnet. Das traf auch den Browser, der nichts
 * gezeichnet hatte. Er holte sie erst beim nächsten Nachladen: Tab wieder
 * sichtbar (höchstens alle 30 s) oder Neuaufbau des Kanals.
 * Gemessen (nginx, 29.09.): Karte um 07:29:38 gespeichert, der Chrome am Mac
 * holte den Verlauf erst um 07:41:16 — rund 11,5 Minuten.
 *
 * ## Die Lösung
 *
 * Jede geöffnete Seite hat eine zufällige Kennung und schickt sie mit dem
 * Sprechtasten-Zug im Kopf mit. Der Server hängt sie an das Kanal-Ereignis.
 * Verworfen wird nur noch das EIGENE Echo; jedes andere Gerät zeichnet die
 * Nachricht sofort.
 *
 * ⚠️ Die Kennung ist keine Anmeldung und kein Geheimnis: Sie gilt für eine
 *    geöffnete Seite, geht nur an Geräte desselben Kontos zurück und
 *    entscheidet nichts außer „habe ich das schon gezeichnet?".
 */

/** Der Kopf, in dem die Seite ihre Kennung mitschickt. */
export const GERAET_KOPF = "X-Vespera-Geraet";

const FORM = /^[a-z0-9]{8,40}$/i;

/** Die Kennung, wenn sie die erwartete Form hat — sonst null. */
export function gueltigeGeraetKennung(wert: unknown): string | null {
  return typeof wert === "string" && FORM.test(wert) ? wert : null;
}

/**
 * Ist dieses Kanal-Ereignis das eigene Sprechtasten-Echo dieser Seite?
 *
 * ⚠️ Ohne Kennung (älterer Stand der Seite, oder ein Weg, der keine
 *    mitschickt) bleibt es beim bisherigen Verwerfen: lieber spät durch den
 *    Nachlauf als doppelt auf dem Telefon.
 */
export function istEigenesPttEcho(
  ereignis: { source?: string; geraet?: string | null },
  eigeneKennung: string,
): boolean {
  if (ereignis.source !== "ptt") return false;
  if (!ereignis.geraet) return true;
  return ereignis.geraet === eigeneKennung;
}
